import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { GetOneflowActionScientificCommitteeBySubTaskId } from "../../../Redux/Reducers/Manager/FlowActionScientificCommittee";
import { useEffect, useState } from "react";
import TableAHSF from "../../../Components/TableDataProps";
import { DeleteItemFromArrayDataCheckBoks } from "../../../Redux/Reducers/Shared/CheckBox";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";

const ApplicationInfoSelectedForScientificCommittee = (props) => {
  // const arrayDataCheckBoks = useSelector(
  //   (state) => state.arrayDataCheckBoks.arrayDataCheckBoks["tasksList"]
  // );
 const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks["tasksList"]
  );
  const { subTaskId } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const lang = useSelector((state) => state.languageReducer.Language);

  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      NmaeColumnEN: " Application Number",
    },
    {
      KeyName: "fullName",
      ShowStatus: true,
      NmaeColumn: " الاسم الكامل",
      NmaeColumnEN: " Full Name",

    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: "الحقل",
      NmaeColumnEN: " Field Name",

    },
    {
      KeyName: "subjectNAme",
      ShowStatus: true,
      NmaeColumn: "الموضوع",
      NmaeColumnEN: " Subject Name",

    },
  ];
  const OtherMainiBtns = [{}];
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["applicationNumber", "ssoguid", "lastUpdate"];
  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        const result = e.target.value;

        console.log(result, "qasem");
        window.open(
          `/ResearchersAward/manager/ViewApplication/ApplicationInformation/` +
            result,
          "_blank"
        );
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض الطلب",
      ShowStatus: true,
    },
    {
          Click: async (e) => {
            const idToRemove = e.currentTarget.value;
            console.log("Removing ID:", idToRemove);
    
            dispatch(
              DeleteItemFromArrayDataCheckBoks({
                KeyName: "tasksList",
                id: idToRemove,
                keyIdName: "applicationInformationId",
              })
            );
    
            dispatch(setRefreshTable({ tableId: "SelectedTable" }));
    
            console.log(" Deleted from Redux & localStorage:", idToRemove);
          },
          className: "bi bi-trash",
          id: "deleteBtn",
          title: "حذف",
          ShowStatus: true,
        },
  ];

  const RequestsManagerColumns = [];
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {},
    componentBody: <div></div>,
    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };
  console.log(arrayDataCheckBoks,"NmaeColumnENFF");

  // useEffect(() => {
  //   dispatch(
  //     GetOneflowActionScientificCommitteeBySubTaskId({ subTaskId: subTaskId })
  //   );
  // }, []);
console.log(arrayDataCheckBoks,"arrayDataCheckBoks");

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"applicationInformationId"}
        valueButtonAction={"applicationInformationId"}
        dataRedux={arrayDataCheckBoks}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الطلبات"}
        titelTableEN="Requests"
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        lang={lang}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        uniqeKeyName={"taskId"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
      />
    </>
  );
};

export default ApplicationInfoSelectedForScientificCommittee;
